import { AccessMethod, IssueTaskCategory } from '@gooduncles/gu-app-schema';

export const requiredRule = [{ required: true, message: '필수 항목입니다!' }];

export const senderKey = process.env.REACT_APP_NHN_NOTIFICATION_SENDERKEY;

export const enum LocalStorageKey {
  deviceInfo = 'deviceInfo',
  storeIssuePrint = 'store-issue-print-table-filter-model',
  dailyOutboundTxnTableFilterModel = 'daily-outbound-txn-table-filter-model-v2',
  dailyOutboundTxnTableColumnState = 'daily-outbound-txn-table-column-state-v2',
  memoWidth = 'memo-width',
  temporaryDeliveryRoute = 'temporary-delivery-route',
  delvierySpot = 'delivery-spot',
  showDeliverySpotSortKey = 'show-delivery-spot-sort-key',
  sessionId = 'gu-session-id',
  sessionDate = 'gu-session-date',
}

export const CommerceIssueSubCategory: Record<string, string[]> = {
  refund: ['파손', '미배송', '불량', '반품', '차액', '기타'],
  order: ['추가주문', '차액추가'],
  discount: ['쿠폰', '기타'],
  delivery: ['배송누락', '기타'],
};

export const commerceIssueStatusKr: Record<string, string> = {
  new: '대기',
  pending: '입력(고객노출)',
  pendingIn: '입력(내부용)',
  ongoing: '확인중',
  resolved: '완료',
  deleted: '삭제',
  hold: '보류',
};

export const billDetailAmountMappings: Record<string, string> = {
  총금액: 'totalAmount',
  공급가: 'supplyAmount',
  세액: 'tax',
};

/**
 * 고객노출 이슈내용의 말머리를 채우기 위한 테이블
 */
export const commerceIssueCategoryTable: Record<string, string> = {
  배송: '★배송-',
  회수: '☆회수-',
  보관: '※보관-',
  식당환불: '※환불-',
  주문수정: '※주문수정-',
  거래처반품: '※거래처반품-',
  거래처매입: '※거래처매입-',
  매입자료수정: '※매입자료수정-',
  매출자료수정: '※매출자료수정-',
  쿠폰할인: '※쿠폰할인-',
  주문: '※주문-',
  기타: '※기타-',
};

/**
 * 고객노출 issueTask의 말머리를 채우기 위한 테이블
 */
export const issueTaskCategoryTable: Record<IssueTaskCategory, string> = {
  [IssueTaskCategory.DELIVERY]: '★배송-',
  [IssueTaskCategory.PICK_UP]: '☆회수-',
  [IssueTaskCategory.QUICK]: '※퀵-',
  [IssueTaskCategory.REFUND]: '※환불-',
  [IssueTaskCategory.ADDITIONAL_CHARGE]: '※추가청구-',
  [IssueTaskCategory.OTHER]: '※기타-',
  [IssueTaskCategory.INTERNAL]: '※내부-',
  [IssueTaskCategory.REQUEST]: '※요청응대-',
};

/**
 * 통계 자료에서 사용할 수 있는 연도
 */
export const availableYearsForStats = {
  2022: '2022',
  2023: '2023',
  2024: '2024',
  2025: '2025',
};
export type AvailableYearForStats = keyof typeof availableYearsForStats;

export const weekdayToKr: Record<string, string> = {
  sun: '일',
  mon: '월',
  tue: '화',
  wed: '수',
  thu: '목',
  fri: '금',
  sat: '토',
};

/**
 * SMS 문자 발신 번호
 */
export const sendNo = '15332537';

/** 파트너스의 업무 유형 KR */
export const taskTypeToKr: Record<string, string> = {
  delivery: '배송',
  return: '회수',
  purchase: '매입',
};

/** 파트너스 기기의 권한 */
export const permissionsKrMap: Record<string, string> = {
  camera: '카메라',
  location: '위치',
  notification: '알림',
  photo: '사진첩',
};

export const permissionStateBall: Record<string, string> = {
  granted: '🟢',
  limited: '🟡',
};

/**
 * 출입 방법 중 사전 체크해야하는 키 유형
 */
export const requiredKeyList: AccessMethod[] = ['cardKey', 'key', 'fingerprint'];

export const partnerTaskModalHeaderStyle: React.CSSProperties = {
  fontSize: '18px',
  fontWeight: '700',
  fontFamily: 'Pretendard',
  backgroundColor: 'inherit',
};
